import useApprovalConditions from '../../hooks/useApprovalConditions';
import { ApprovalSummaryI18nAllApproved, ApprovalSummaryI18nPartiallyApproved } from '../i18n/ApprovalSummaryI18n';
import { jsx as _jsx } from "react/jsx-runtime";
// This only shows message for an Approver who has approved
function ApprovalSummary(props) {
  const {
    isApproved,
    isNotStarted,
    isUserStepApproved
  } = useApprovalConditions();
  if (isNotStarted) {
    return null;
  }
  if (isUserStepApproved) {
    return /*#__PURE__*/_jsx("p", Object.assign({}, props, {
      children: isApproved ? /*#__PURE__*/_jsx(ApprovalSummaryI18nAllApproved, {}) : /*#__PURE__*/_jsx(ApprovalSummaryI18nPartiallyApproved, {})
    }));
  }
  return null;
}
export default ApprovalSummary;